import React from 'react';
import { XCircle } from 'lucide-react';
export function WhyNotWorkedSection() {
  const failures = [{
    title: 'Castigos severos o quitar el celular de golpe',
    reason: 'Genera resentimiento, rebeldía y los hace esconderse más. El celular es su vida social; quitárselo se siente como un ataque personal.'
  }, {
    title: 'Apagar el WiFi de la casa',
    reason: "Inicia una 'guerra fría' familiar. Resuelve el síntoma por unas horas, pero destruye la confianza a largo plazo."
  }, {
    title: 'Sermones interminables sobre los peligros',
    reason: "Los adolescentes simplemente 'apagan' su atención cuando empezamos a dar discursos. Sienten que no entendemos su mundo."
  }];
  return <section className="bg-alternate py-10 md:py-24 px-4" data-id="element-251">
      <div className="max-w-4xl mx-auto" data-id="element-252">
        <div className="text-center mb-8 md:mb-14" data-id="element-253">
          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-4 md:mb-6" data-id="element-254">
            Por qué lo que has intentado hasta ahora no ha funcionado
          </h2>
          <p className="text-base md:text-lg text-text-secondary" data-id="element-255">
            Si sientes que has probado de todo sin éxito, es porque los métodos
            tradicionales de disciplina chocan directamente con cómo funciona el
            cerebro adolescente hoy.
          </p>
        </div>

        <div className="space-y-4 md:space-y-6" data-id="element-256">
          {failures.map((item, index) => <div key={index} className="flex flex-col md:flex-row gap-3 md:gap-6 bg-accent/50 p-5 md:p-8 rounded-2xl border border-border/50" data-id="element-257">
              <div className="flex-shrink-0" data-id="element-258">
                <XCircle className="w-7 h-7 md:w-8 md:h-8 text-coral opacity-80" data-id="element-259" />
              </div>
              <div data-id="element-260">
                <h3 className="text-lg md:text-xl font-bold text-text-primary mb-1.5 md:mb-2" data-id="element-261">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base text-text-secondary leading-relaxed" data-id="element-262">
                  {item.reason}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-8 md:mt-12 text-center" data-id="element-263">
          <p className="text-lg md:text-xl font-medium text-text-primary" data-id="element-264">
            Para cambiar el resultado, necesitamos cambiar el enfoque.
          </p>
        </div>
      </div>
    </section>;
}